export default {
  "config": {
    "trial": "tones-3",
    "id": "mwt-indiv",
    "type": "line",
    "title": "Durability of Change in Sleep Latency Throughout the Day at Week 12<sup>23</sup>",
    "xAxis": {
      "groups": [
        "1",
        "2",
        "3",
        "4",
        "5"
      ],
      "padding": 0.1,
      "label": {
        "text": "MWT trial<sup>a</sup> (time postdose)"
      },
      "overrides": {
        "1": "Trial 1<br><no-break>(1 h)</no-break>",
        "2": "Trial 2<br><no-break>(3 h)</no-break>",
        "3": "Trial 3<br><no-break>(5 h)</no-break>",
        "4": "Trial 4<br><no-break>(7 h)</no-break>",
        "5": "Trial 5<br><no-break>(9 h)</no-break>"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": -2,
      "high": 18,
      "inc": 2,
      "label": {
        "text": [
          "Change from baseline,",
          "<no-break>LS mean (SE), min</no-break>"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo",
        "label": "Placebo <no-break>(n = 114)</no-break>",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo"
      },
      {
        "entry": "sol-375",
        "label": "Solriamfetol <no-break>37.5 mg</no-break> <no-break>(n = 56)</no-break>",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 37.5 mg"
      },
      {
        "entry": "sol-75",
        "label": "Solriamfetol <no-break>75 mg</no-break> <no-break>(n = 58)</no-break>",
        "color": "#ffce00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 75 mg"
      },
      {
        "entry": "sol-150",
        "label": "Solriamfetol <no-break>150 mg</no-break> <no-break>(n = 116)</no-break>",
        "color": "#73cac3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 150 mg"
      },
      {
        "entry": "sol-300",
        "label": "Solriamfetol <no-break>300 mg</no-break> <no-break>(n = 115)</no-break>",
        "color": "#be5b92",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 300 mg"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<no-break>*<em>P</em> < 0.05</no-break> vs placebo;<no-break> <sup>#</sup><em>P</em> < 0.0001</no-break> vs placebo.",
      "<sup>a</sup>Individual MWT trials, each of 40-minute duration, were performed at 2-hour intervals beginning 2 hours after awakening and 1 hour after dosing at the approximate times postdose shown in parentheses. The result at trial 4 for 37.5 mg was of nominal significance based on the prespecified testing sequence."
    ],
    "useFootnoteTooltip": true,
    "trendLines": [],
    "tooltipHeaders": [
      "Treatment group",
      "min"
    ],
    "nValueTable": {
      "type": "regular",
      "rows": 1,
      "sourceField": "y"
    },
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo",
            "label": "Placebo <no-break>(n = 114)</no-break>",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-375",
            "label": "Solriamfetol <no-break>37.5 mg</no-break> <no-break>(n = 56)</no-break>",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 37.5 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-75",
            "label": "Solriamfetol <no-break>75 mg</no-break> <no-break>(n = 58)</no-break>",
            "color": "#ffce00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 75 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-150",
            "label": "Solriamfetol <no-break>150 mg</no-break> <no-break>(n = 116)</no-break>",
            "color": "#73cac3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 150 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-300",
            "label": "Solriamfetol <no-break>300 mg</no-break> <no-break>(n = 115)</no-break>",
            "color": "#be5b92",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 300 mg"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "name": "pbo",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo",
          "color": "#868686",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Placebo, LS mean",
          "tooltipLabel": "Placebo",
          "points": [
            {
              "x": 1,
              "y": -0.4,
              "extreme": {
                "upper": 1.327,
                "lower": 1.327
              },
              "label": {
                "text": -0.4,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": -0.44,
              "extreme": {
                "upper": 1.38,
                "lower": 1.38
              },
              "label": {
                "text": -0.44,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 0.58,
              "extreme": {
                "upper": 1.294,
                "lower": 1.294
              },
              "label": {
                "text": 0.58,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": 1.29,
              "extreme": {
                "upper": 1.305,
                "lower": 1.305
              },
              "label": {
                "text": 1.29,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": 0.18,
              "extreme": {
                "upper": 1.361,
                "lower": 1.361
              },
              "label": {
                "text": 0.18,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-375",
      "color": "#006e8a",
      "sets": [
        {
          "name": "sol-375",
          "color": "#006e8a",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 37.5 mg, LS mean",
          "tooltipLabel": "Solriamfetol 37.5 mg",
          "points": [
            {
              "x": 1,
              "y": 3.03,
              "extreme": {
                "upper": 1.881,
                "lower": 1.881
              },
              "label": {
                "text": 3.03,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 6.93,
              "extreme": {
                "upper": 1.928,
                "lower": 1.928
              },
              "label": {
                "text": 6.93,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 3.59,
              "extreme": {
                "upper": 1.837,
                "lower": 1.837
              },
              "label": {
                "text": 3.59,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": 6.11,
              "extreme": {
                "upper": 1.845,
                "lower": 1.845
              },
              "label": {
                "text": 6.11,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": 3.57,
              "extreme": {
                "upper": 1.952,
                "lower": 1.952
              },
              "label": {
                "text": 3.57,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-75",
      "color": "#ffce00",
      "sets": [
        {
          "name": "sol-75",
          "color": "#ffce00",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 75 mg, LS mean",
          "tooltipLabel": "Solriamfetol 75 mg",
          "points": [
            {
              "x": 1,
              "y": 5.77,
              "extreme": {
                "upper": 1.808,
                "lower": 1.808
              },
              "label": {
                "text": 5.77,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 9.47,
              "extreme": {
                "upper": 1.849,
                "lower": 1.849
              },
              "label": {
                "text": 9.47,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 11.32,
              "extreme": {
                "upper": 1.751,
                "lower": 1.751
              },
              "label": {
                "text": 11.32,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": 9.04,
              "extreme": {
                "upper": 1.794,
                "lower": 1.794
              },
              "label": {
                "text": 9.04,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": 7.75,
              "extreme": {
                "upper": 1.839,
                "lower": 1.839
              },
              "label": {
                "text": 7.75,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-150",
      "color": "#73cac3",
      "sets": [
        {
          "name": "sol-150",
          "color": "#73cac3",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 150 mg, LS mean",
          "tooltipLabel": "Solriamfetol 150 mg",
          "points": [
            {
              "x": 1,
              "y": 10.87,
              "extreme": {
                "upper": 1.284,
                "lower": 1.284
              },
              "label": {
                "text": 10.87,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 11.91,
              "extreme": {
                "upper": 1.332,
                "lower": 1.332
              },
              "label": {
                "text": 11.91,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 11.5,
              "extreme": {
                "upper": 1.261,
                "lower": 1.261
              },
              "label": {
                "text": 11.5,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": 8.93,
              "extreme": {
                "upper": 1.272,
                "lower": 1.272
              },
              "label": {
                "text": 8.93,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": 8.05,
              "extreme": {
                "upper": 1.347,
                "lower": 1.347
              },
              "label": {
                "text": 8.05,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-300",
      "color": "#be5b92",
      "sets": [
        {
          "name": "sol-300",
          "color": "#be5b92",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 300 mg, LS mean",
          "tooltipLabel": "Solriamfetol 300 mg",
          "points": [
            {
              "x": 1,
              "y": 12.48,
              "extreme": {
                "upper": 1.401,
                "lower": 1.401
              },
              "label": {
                "text": 12.48,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 14.94,
              "extreme": {
                "upper": 1.425,
                "lower": 1.425
              },
              "label": {
                "text": 14.94,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 10.9,
              "extreme": {
                "upper": 1.34,
                "lower": 1.34
              },
              "label": {
                "text": 10.9,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": 11.94,
              "extreme": {
                "upper": 1.359,
                "lower": 1.359
              },
              "label": {
                "text": 11.94,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": 7.59,
              "extreme": {
                "upper": 1.432,
                "lower": 1.432
              },
              "label": {
                "text": 7.59,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    }
  ]
};